import React from 'react';

const Profile: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-navy-950 dark:text-white mb-8">
        My Profile
      </h1>
      <div className="card">
        <p className="text-gray-600 dark:text-gray-300">
          Profile management coming soon...
        </p>
      </div>
    </div>
  );
};

export default Profile;
